import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { DatasearchService } from '../../_services/datasearch.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Validator function for matching passwords
function passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const group = control as FormGroup;
  const newPassword = group.get('newpassword');
  const confirmPassword = group.get('password');

  if (newPassword && confirmPassword && newPassword.value !== confirmPassword.value) {
    return { 'mismatch': true };
  }
  return null;
}

@Component({
  selector: 'app-reset-pswd',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule
  ],
  templateUrl: './reset-pswd.component.html',
  styleUrls: ['./reset-pswd.component.scss']
})
export class ResetPswdComponent implements OnInit {
  resetpswdForm: FormGroup = this.fb.group({});
  alertVisible: boolean = false;
  passwordMismatch: boolean = false;
  username: string = ''; 
  authKey: string = ''; 

  constructor(
    private fb: FormBuilder,
    private datasearch: DatasearchService,
    private route: ActivatedRoute,
    private router: Router 
  ) {}

  ngOnInit() {
    this.initPasswordForm();
    this.route.paramMap.subscribe(params => {
      this.username = this.route.snapshot.paramMap.get('username') || ''; // Assuming email is part of route parameters
      this.authKey = this.route.snapshot.paramMap.get('authKey') || ''; // Assuming authKey is part of route parameters
    });
  }

  initPasswordForm() {
    this.resetpswdForm = this.fb.group({
      newpassword: ['', Validators.required],
      password: ['', Validators.required]
    }, { validator: passwordMatchValidator });
  }

  ResetPassword() {
    if (this.resetpswdForm.valid && !this.resetpswdForm.errors?.['mismatch']) {
      this.passwordMismatch = false;
  
      // Create a FormData object
      const formData = new FormData();
      formData.append('password', this.resetpswdForm.get('password')?.value || ''); // Include the new password
      formData.append('authKey', this.authKey); // Include the auth key from the URL
      formData.append('username', this.username); // Include the email from the URL
  
      // Send the form data
      this.datasearch.sendResetpswd(formData).subscribe(
        (response: any) => {
          if (response.status === 'success') {
            this.initPasswordForm();
            // console.log('Update successful, showing alert.');
            this.showSuccessAlert();
            // Redirect to home page after successful update
            this.router.navigate(['/home']);
          }
        },
        (error) => {
          console.error(error); // Handle error response
        }
      );
    } else if (this.resetpswdForm.errors?.['mismatch']) {
      this.passwordMismatch = true;
      console.log('Passwords do not match.');
    }
  }

  showSuccessAlert(): void {
    this.alertVisible = true;
    setTimeout(() => this.closeAlert(), 5000); // Hide alert after 5 seconds
  }

  closeAlert(): void {
    this.alertVisible = false;
  }
}
